export const WeaponImage = ({weapon, style}) => weapon ? <img
    src={require('../assets/weapons/' + weapon.toLowerCase().replaceAll(' ', '-').replaceAll('.', '') + '.png')}
    alt={weapon} style={style}/> : null